import {EntityManagePage} from "base/entity";
import {useConfigModule} from "base/provider";

const ManageCaptacionPage = () => {
    const {moduleFilter} = useConfigModule();

    return <EntityManagePage filter={moduleFilter}></EntityManagePage>;
};
export default ManageCaptacionPage;
